import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { useInfluencerCampaignListByPromotionMethodQuery } from '@anytag/graphql';
import { useCampaignsListTable } from './hooks';

interface CampaignsSummaryProps {
  influencerId: number;
  socialAccountId: number;
}
export const CampaignsList = ({ influencerId, socialAccountId }: CampaignsSummaryProps) => {
  const { t } = useTranslation();
  const { data, loading } = useInfluencerCampaignListByPromotionMethodQuery({
    fetchPolicy: 'network-only',
    variables: { influencerId, promotionMethodId: socialAccountId }
  });
  const { columns } = useCampaignsListTable();

  return (
    <TableV2
      loading={loading}
      data={data?.influencerCampaignListByPromotionMethod || []}
      columns={columns}
      rowHeight="70px"
      empty={{ hideDescription: true, title: t('No campaigns has been found') }}
      noTopBorderRadius
      hasBorder
    />
  );
};
